import { connectedStore } from '../../store';
import actions from '../actions';

const reloadSiteMeta = (site) =>
  new Promise((resolve, reject) => {
    const store = connectedStore.get();
    store.dispatch(actions.reloadSiteMeta(site, resolve, reject));
  });

export default reloadSiteMeta;
